import SupaBaseModel from "./SupaBaseModel";
import {SupabaseClient} from "./SuperbaseClient";

export default class Salon extends SupaBaseModel {
    static data_name = 'salons';

    static newDefault(){
        let instance = new this();
        instance.active = true;
        instance.name = "";
        instance.phone = "";
        instance.address = "";
        instance.suburb = "";
        instance.postcode = "";
        instance.state_id = 0;
        instance.trading_hours = "";
        instance.description = "";
        instance.latitude = -33.884975;
        instance.longitude = 151.215396;
        return instance;
    }

    static async getWithDetails(id){
        const { data, error } = await SupabaseClient.from('salon_details')
            .select()
            .eq('id', id)
            .limit(1);

        if(error)
            throw error;

        return data.length < 1 ? null : this.instanceFromData(data[0]);
    }

    static async allActiveWithDetails(limit = 500){
        const { data, error } = await SupabaseClient.from('salon_details')
            .select()
            .eq("active", true)
            .order('id', { ascending: false })
            .limit(limit);

        if(error)
            throw error;

        return this.instanceItemsFromData(data);
    }

    static async allWithDetails(limit = 500){
        const { data, error } = await SupabaseClient.from('salon_details')
            .select()
            .order('id', { ascending: false })
            .limit(limit);

        if(error)
            throw error;

        return this.instanceItemsFromData(data);
    }

    get created_at_format(){
        return this.formatDate(this.created_at);
    }

    get main_image_url(){
        return this.images && this.images.length > 0 ? this.images[0] : "";
    }

    get main_thumb_url(){
        return this.thumb_images && this.thumb_images.length > 0 ? this.thumb_images[0] : "";
    }

    get full_address(){
        return [this.address, this.suburb, this.state_abbreviation, this.postcode].filter(p => p && p.length > 0).join(", ");
    }
}
